import React from 'react';
import PropTypes from 'prop-types';
import AbstractField from "mc/lib/field/AbstractField";
import * as commons from "mc/lib/utils/commons";
import {field} from "mc/lib";

/**
 * Field umožňující výběr data a času.
 */
class DateTimeField extends AbstractField {

    static propTypes = {
        onChange: PropTypes.func,
        value: PropTypes.string,
        datePlaceholder: PropTypes.string,
        timePlaceholder: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: this.getValueFromProps(props.value)
        }
    }

    getValueFromProps = (value) => {
        return (value && value !== "") ? commons.localUTCToDateTime(value) : null;
    };

    onDateChange = (date) => {
        if (date.target) {
            date = date.target.value;
        }
        const {onChange} = this.props;
        date = new Date(date);
        const current = this.state.value instanceof Date || this.state.value === null ? this.state.value : new Date(this.state.value);
        const value = commons.combineDateTime(date, current);
        this.setState({value: value});
        onChange(value);
    };

    onTimeChange = (time) => {
        if (time.target) {
            time = time.target.value;
        }
        time = new Date('1970-01-01 ' + time);
        const {onChange} = this.props;
        const current = this.state.value instanceof Date || this.state.value === null ? this.state.value : new Date(this.state.value);
        const value = commons.combineDateTime(current, time);
        this.setState({value: value});
        onChange(value);
    };

    render() {
        const {datePlaceholder, timePlaceholder} = this.props;
        return <div>
            <field.SimpleDate placeholder={datePlaceholder} onChange={this.onDateChange} value={this.state.value} />
            <field.Time timeFormat={'HH:mm:ss'} format={'HH:mm:ss'} placeholder={timePlaceholder} onChange={this.onTimeChange} value={this.state.value} />
        </div>;
    }
}

export default DateTimeField;
